import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_134: FaireProductEntity = {
  token: "legacy_prod_abbott-134",
  type: "product",
  name: "Blue and White Umbrella Stand-18 H 6 D",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/aa8eb4c582c736af2dba2fc852bf4c8ef93f291f72e4122112e203cd2d34e054.jpeg",
  priceDollars: 48,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
